import { render, staticRenderFns } from "./DateIcon.vue?vue&type=template&id=1d284998"
import script from "./DateIcon.vue?vue&type=script&lang=js"
export * from "./DateIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports